export default "__VITE_ASSET__kwR$6rcY__"